import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useTheme } from "../../theme/ThemeProvider";

const Breadcrumb = ({ items, currentPage }) => {
  const { isDarkMode } = useTheme();

  const homeIcon = (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 512 512"
      className={`ltr:mr-1.5 rtl:ml-1.5 text-15px inline-block align-middle ${
        isDarkMode ? "text-gray-300" : "text-[#000000]"
      }`}
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="M80 212v236a16 16 0 0 0 16 16h96V328a24 24 0 0 1 24-24h80a24 24 0 0 1 24 24v136h96a16 16 0 0 0 16-16V212"
      ></path>
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="M480 256 266.89 52c-5-5.28-16.69-5.34-21.78 0L32 256m368-77V64h-48v69"
      ></path>
    </svg>
  );

  const separator = (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 512 512"
      className={`text-15px inline-block align-middle ${
        isDarkMode ? "text-gray-600" : "text-brand-dark text-opacity-40"
      }`}
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="48"
        d="m184 112 144 144-144 144"
      ></path>
    </svg>
  );

  return (
    <div className="flex items-center">
      <ol className="flex items-center w-full overflow-hidden">
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <li className="flex items-center">
              <Link to={item.path}>
                <div
                  className={`flex items-center text-sm px-2.5 transition duration-200 ease-in ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 ${
                    isDarkMode
                      ? "text-gray-400 hover:text-gray-200"
                      : "text-brand-muted hover:text-brand-dark"
                  }`}
                >
                  {item.icon && homeIcon}
                  <span className="inline-block leading-none align-middle">
                    {item.label}
                  </span>
                </div>
              </Link>
            </li>
            {index < items.length - 1 && (
              <li className="flex items-center justify-center">
                <span className="flex items-center mx-1 leading-none">
                  {separator}
                </span>
              </li>
            )}
          </React.Fragment>
        ))}
        {currentPage && (
          <>
            <li className="flex items-center justify-center">
              <span className="flex items-center mx-1 leading-none">
                {separator}
              </span>
            </li>
            <li className="flex items-center">
              <Link to={currentPage.path}>
                <span
                  className={`flex items-center text-sm px-2.5 transition duration-200 ease-in ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 ${
                    isDarkMode
                      ? "text-gray-400 hover:text-gray-200"
                      : "text-brand-muted hover:text-brand-dark"
                  }`}
                >
                  <span className="inline-block leading-none align-middle">
                    {currentPage.label}
                  </span>
                </span>
              </Link>
            </li>
          </>
        )}
      </ol>
    </div>
  );
};

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      icon: PropTypes.bool
    })
  ).isRequired,
  currentPage: PropTypes.shape({
    label: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired
  })
};

export default Breadcrumb;